module.exports = __webpack_public_path__ + "img/success_icon.1950fd8a.svg";